import { morph } from '@theme/morph';
import { StandardEvents } from '@shopify/events';

class CentreCapProductSpecifications extends HTMLElement {
  section;

  connectedCallback() {
    this.section = this.closest('.shopify-section, dialog');
    this.section?.addEventListener(StandardEvents.productSelect, this.handleProductSelect);
  }

  disconnectedCallback() {
    this.section?.removeEventListener(StandardEvents.productSelect, this.handleProductSelect);
  }

  handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        const { html, newProduct, productId } = detail;
        if (newProduct) {
          this.dataset.productId = newProduct.id;
        } else if (productId && productId !== this.dataset.productId) {
          return;
        }

        const blockId = CSS.escape(this.dataset.blockId ?? '');
        const updated = html.querySelector(`centre-cap-product-specifications[data-block-id="${blockId}"]`);
        if (!updated) return;

        this.dataset.productId = updated.dataset.productId ?? this.dataset.productId;
        this.toggleAttribute('hidden', updated.hasAttribute('hidden'));
        morph(this, updated, { childrenOnly: true });
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[centre-cap-specifications] Variant update failed:', error);
      });
  };
}

if (!customElements.get('centre-cap-product-specifications')) {
  customElements.define('centre-cap-product-specifications', CentreCapProductSpecifications);
}

class CentreCapProductQuestion extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.form?.addEventListener('formdata', this.handleFormData);
  }

  disconnectedCallback() {
    this.form?.removeEventListener('formdata', this.handleFormData);
  }

  handleFormData = (event) => {
    const productDetails = this.closest('.product-details') ?? document;
    const diameterOptions = productDetails.querySelectorAll('[data-option-name]');
    const selectedDiameter = Array.from(diameterOptions).find((option) => {
      if (option.dataset.optionName?.trim().toLowerCase() !== 'diameter') return false;

      if (option instanceof HTMLInputElement) return option.checked;
      if (option instanceof HTMLOptionElement) return option.selected;

      return false;
    });
    const displayedDiameter = productDetails.querySelector(
      ".variant-option--centre-cap-diameter[data-testid='variant-option-single'] .variant-option__swatch-value"
    );
    const diameter = selectedDiameter?.value?.trim() || displayedDiameter?.textContent?.trim();
    const variantId = productDetails.querySelector('product-form-component input[name="id"]')?.value?.trim();

    if (diameter) event.formData.set('contact[Selected Diameter]', diameter);
    if (variantId) event.formData.set('contact[Variant ID]', variantId);
  };
}

if (!customElements.get('centre-cap-product-question')) {
  customElements.define('centre-cap-product-question', CentreCapProductQuestion);
}
